import { QuestionPicker } from 'pages/custom_tests_v1/components/question_picker/QuestionPicker';
import { useCustomTestEdit } from 'pages/custom_tests_v1/components/custom_test_edit/context';
import { useCustomTests } from 'pages/custom_tests_v1/context';
import { useRegisterHeaderControls } from 'components/layout';
import { FAIcon } from 'components/fontawesome_icon/FAIcon';
import { FormattedMessage, useIntl } from 'react-intl';

export const QuestionsTab = props => {

    const { handleQuestionsChange, handleSave, hasResults, loading, loadingQuestions, questionTree, saving, selectedQuestionIds } = useCustomTestEdit();
    const { permissions } = useCustomTests();
    const { formatMessage } = useIntl();

    useRegisterHeaderControls(permissions.CanEdit ? {
        cta: {
            disabled: loading || saving,
            label: formatMessage({ id: 'save.d44082ae', defaultMessage: 'Save' }),
            onClick: () => handleSave()
        }
    } : null);

    return (
        <div className="questions-tab">
            {hasResults ?
                (
                    <div className="alert alert-warning d-flex align-items-center">
                        <FAIcon
                            className={'text-warning me-2'}
                            library={'solid'}
                            name={'triangle-exclamation'}
                            style={{ fontSize: '1.25rem' }}
                        />
                        <span>
                            <FormattedMessage defaultMessage="Questions cannot be changed for tests with existing results. Consider cloning this test instead." id="questions_cannot_be_changed_for_tests_wi.e076ea72" />
                        </span>
                    </div>
                )
                :
                (
                    <QuestionPicker
                        loading={loadingQuestions}
                        onChange={handleQuestionsChange}
                        questionTree={questionTree}
                        selectedIds={selectedQuestionIds}
                    />
                )
            }
        </div>
    );

};
